export default __webpack_public_path__ + "static/media/EndAdorment.a6bd1707.svg";